import React, { useState } from 'react';
import {
  Stack,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';

import 'handsontable/dist/handsontable.full.min.css';
import { registerAllModules } from 'handsontable/registry';
import { useLocalization } from 'src/context/LocalizationContext';
import DhlReport from './Views/DHLReport';
import EticaretReport from './Views/ECommerceReport';
import TaxFreeReport from './Views/TaxFreeReport';
import ArasReport from './Views/ArasFastReport';

registerAllModules();

export default function FastReport() {
  const parsedUser = JSON.parse(localStorage.getItem('user'));
  const { language } = useLocalization();
  const [selectedTab, setSelectedTab] = useState("E-TİCARET");

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const tabsComponent = (
    <Tabs
      value={selectedTab}
      onChange={handleTabChange}
      aria-label="Kargo Seçimi"
      sx={{ borderBottom: 1, borderColor: 'divider' }}
    >
      <Tab label="E-TİCARET" value="E-TİCARET" />
      <Tab label="DHL" value="DHL" />
      <Tab label="TAX FREE" value="TAX FREE" />
      <Tab label="ARAS" value="ARAS" />
    </Tabs>
  );

  return (
    <>
      <Helmet>
        <title>{language.fast_report.titles.site_title}</title>
      </Helmet>
      <Stack style={{ paddingInline: '25px' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {language.fast_report.titles.title}
          </Typography>
        </Stack>

        {selectedTab === 'DHL' && <DhlReport parsedUser={parsedUser} language={language} tabs={tabsComponent} />}
        {selectedTab === 'TAX FREE' && <TaxFreeReport parsedUser={parsedUser} language={language} tabs={tabsComponent} />}
        {selectedTab === 'ARAS' && <ArasReport parsedUser={parsedUser} language={language} tabs={tabsComponent} />}
        {selectedTab === 'E-TİCARET' && <EticaretReport parsedUser={parsedUser} language={language} tabs={tabsComponent} />}
      </Stack>
    </>
  );
}
